import { makeStyles } from "@material-ui/core/styles";
import { SEARCH_STYLE as S } from "./M_GlobalSearch.config";

export const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center",
    padding: theme.spacing(2),
  },
  backdrop: {
    backgroundColor: S.backdropColor,
    backdropFilter: S.backdropBlur,
    WebkitBackdropFilter: S.backdropBlur,
  },
  palette: {
    position: "relative",
    outline: "none",
    marginTop: S.paletteMarginTop,
    width: S.paletteWidth,
    maxHeight: S.paletteMaxHeight,
    display: "flex",
    flexDirection: "column",
    color: "var(--color-text-primary)",
    background: "var(--color-background-paper)",
    backgroundColor: S.paletteBg,
    backgroundImage: S.paletteSheen,
    border: S.paletteBorder,
    borderRadius: S.paletteRadius,
    boxShadow: S.paletteShadow,
    backdropFilter: S.paletteBlur,
    WebkitBackdropFilter: S.paletteBlur,
    overflow: "hidden",
    "&::before": {
      content: '""',
      position: "absolute",
      inset: 0,
      background: S.paletteSpecular,
      pointerEvents: "none",
      zIndex: 0,
    },
    "& > *": {
      position: "relative",
      zIndex: 1,
    },
    [theme.breakpoints.down("xs")]: {
      marginTop: S.paletteMarginTopXs,
      width: "100%",
      maxHeight: S.paletteMaxHeightXs,
    },
  },
  header: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
    padding: theme.spacing(1.75, 2.25),
    borderBottom: S.glassDivider,
  },
  headerIcon: {
    color: "var(--color-text-secondary)",
    display: "flex",
    fontSize: S.fontHeaderIcon,
  },
  input: {
    flex: 1,
    border: 0,
    outline: 0,
    background: "transparent",
    color: "var(--color-text-primary)",
    fontFamily: "inherit",
    fontSize: S.fontInput,
    lineHeight: 1.4,
    "&::placeholder": {
      color: "var(--color-text-secondary)",
      opacity: 1,
    },
  },
  tabs: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(0.75),
    flexWrap: "wrap",
    padding: theme.spacing(1, 1.5),
    borderBottom: S.glassDivider,
  },
  tab: {
    border: "1px solid transparent",
    background: "transparent",
    color: "var(--color-text-secondary)",
    cursor: "pointer",
    fontFamily: "inherit",
    fontSize: S.fontTab,
    fontWeight: 600,
    lineHeight: 1,
    letterSpacing: "0.01em",
    padding: theme.spacing(0.5, 1.25),
    borderRadius: S.pillRadius,
    display: "inline-flex",
    alignItems: "center",
    gap: theme.spacing(0.75),
    transition: S.transitionTab,
    "&:hover": {
      background: "var(--search-item-hover-bg)",
      color: "var(--color-text-primary)",
    },
  },
  tabActive: {
    background: "var(--color-primary-main)",
    backgroundImage: S.tabActiveSheen,
    color: "var(--color-primary-contrast)",
    borderColor: "rgba(255, 255, 255, 0.25)",
    boxShadow: S.tabActiveShadow,
    "&:hover": {
      background: "var(--color-primary-main)",
      backgroundImage: S.tabActiveSheen,
      color: "var(--color-primary-contrast)",
    },
  },
  tabCount: {
    fontSize: S.fontMicro,
    fontWeight: 700,
    opacity: 0.85,
    background: S.tabCountBg,
    borderRadius: S.pillRadius,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: S.tabCountMinWidth,
    height: S.tabCountMinWidth,
    padding: theme.spacing(0, 0.625),
    lineHeight: 1,
  },
  tabCountIdle: {
    background: "var(--total_row_boldbackground)",
    color: "var(--color-text-secondary)",
  },
  body: {
    flex: 1,
    overflowY: "auto",
    padding: theme.spacing(0.5, 0),
  },
  groupLabel: {
    padding: theme.spacing(1, 2.25, 0.5),
    fontSize: S.fontMicro,
    fontWeight: 700,
    letterSpacing: "0.04em",
    textTransform: "capitalize",
    color: "var(--color-text-secondary)",
  },
  groupHeader: {
    display: "flex",
    alignItems: "baseline",
    justifyContent: "space-between",
    paddingRight: theme.spacing(2.25),
  },
  groupAction: {
    border: 0,
    background: "transparent",
    cursor: "pointer",
    fontFamily: "inherit",
    fontSize: S.fontMicro,
    fontWeight: 700,
    letterSpacing: "0.04em",
    textTransform: "uppercase",
    color: "var(--color-primary-text)",
    padding: 0,
  },
  row: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
    padding: theme.spacing(1, 2.25),
    cursor: "pointer",
    borderLeft: `${S.rowActiveBorderWidth}px solid transparent`,
    transition: S.transitionRow,
  },
  rowActive: {
    background: "var(--search-item-hover-bg)",
    borderLeft: `${S.rowActiveBorderWidth}px solid var(--color-primary-main)`,
  },
  avatar: {
    flexShrink: 0,
    width: S.avatarSize,
    height: S.avatarSize,
    display: "grid",
    placeItems: "center",
    color: "var(--color-primary-text)",
    "& svg": {
      fontSize: S.avatarIconSize,
    },
  },
  rowText: {
    flex: 1,
    minWidth: 0,
  },
  heading: {
    fontSize: S.fontHeading,
    fontWeight: 500,
    color: "var(--color-text-primary)",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  subHeading: {
    fontSize: S.fontSubHeading,
    color: "var(--color-text-secondary)",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  highlight: {
    background: S.highlightBg,
    color: "var(--color-primary-text)",
    fontWeight: 700,
    borderRadius: 2,
    padding: 0,
  },
  rowMeta: {
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
  },
  typeChip: {
    fontSize: S.fontChip,
    fontWeight: 600,
    textTransform: "capitalize",
    color: "var(--color-text-secondary)",
    background: "var(--total_row_boldbackground)",
    borderRadius: S.pillRadius,
    padding: theme.spacing(0.25, 1),
  },
  tagChip: {
    fontSize: S.fontChip,
    fontWeight: 600,
    color: "var(--color-primary-text)",
    background: S.tagChipBg,
    border: S.tagChipBorder,
    borderRadius: S.pillRadius,
    padding: theme.spacing(0.25, 1),
    whiteSpace: "nowrap",
    maxWidth: S.tagChipMaxWidth,
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  enterHint: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: S.enterHintSize,
    height: S.enterHintSize,
    padding: theme.spacing(0, 0.5),
    borderRadius: S.kbdRadius,
    border: S.kbdGlassBorder,
    background: S.kbdGlassBg,
    color: "var(--color-primary-text)",
    fontSize: S.fontEnterHint,
    fontWeight: 600,
    lineHeight: 1,
  },
  state: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    gap: theme.spacing(1),
    padding: theme.spacing(5, 3),
    color: "var(--color-text-secondary)",
  },
  stateIcon: {
    fontSize: S.fontStateIcon,
    color: "var(--color-text-secondary)",
    opacity: 0.6,
  },
  stateTitle: {
    fontSize: S.fontStateTitle,
    fontWeight: 600,
    color: "var(--color-text-primary)",
  },
  stateHint: {
    fontSize: S.fontStateHint,
  },
  retryButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: theme.spacing(0.75),
    marginTop: theme.spacing(0.5),
    border: "1px solid var(--color-primary-main)",
    background: "transparent",
    cursor: "pointer",
    fontFamily: "inherit",
    fontSize: S.fontStateHint,
    fontWeight: 600,
    color: "var(--color-primary-text)",
    borderRadius: S.kbdRadius,
    padding: theme.spacing(0.5, 1.5),
    transition: S.transitionRow,
    "&:hover": {
      background: "var(--search-item-hover-bg)",
    },
  },
  skeletonRow: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
    padding: theme.spacing(1, 2.25),
  },
  footer: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
    padding: theme.spacing(1, 2.25),
    borderTop: S.glassDivider,
    color: "var(--color-text-secondary)",
    fontSize: S.fontMicro,
    flexWrap: "wrap",
  },
  footerItem: {
    display: "inline-flex",
    alignItems: "center",
    gap: theme.spacing(0.5),
  },
  kbd: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: S.kbdMinWidth,
    padding: theme.spacing(0.25, 0.5),
    borderRadius: S.kbdRadius,
    border: S.kbdGlassBorder,
    background: S.kbdGlassBg,
    color: "var(--color-text-secondary)",
    fontSize: S.fontMicro,
    fontWeight: 600,
    lineHeight: 1.4,
  },
  trigger: {
    display: "inline-flex",
    alignItems: "center",
    gap: theme.spacing(1),
    cursor: "text",
    border: S.triggerBorder,
    borderRadius: S.pillRadius,
    background: S.triggerBg,
    backdropFilter: S.triggerBlur,
    WebkitBackdropFilter: S.triggerBlur,
    color: S.triggerColor,
    padding: theme.spacing(0.50, 1.25),
    minWidth: S.triggerMinWidth,
    transition: S.transitionTrigger,
    "&:hover": {
      background: S.triggerBgHover,
      borderColor: S.triggerBorderHover,
    },
    [theme.breakpoints.down("sm")]: {
      minWidth: 0,
      border: "none",
      background: "transparent",
      backdropFilter: "none",
      WebkitBackdropFilter: "none",
      cursor: "pointer",
      padding: theme.spacing(0.5),
      "&:hover": {
        background: "transparent",
        borderColor: "transparent",
      },
    },
  },
  triggerIcon: {
    display: "flex",
    fontSize: S.fontTriggerIcon,
    opacity: 0.85,
    [theme.breakpoints.down("sm")]: {
      fontSize: "1rem",
      opacity: 1,
      color: "#faf6f6",
    },
  },
  triggerLabel: {
    flex: 1,
    textAlign: "left",
    fontSize: S.fontTrigger,
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  triggerKbd: {
    display: "inline-flex",
    alignItems: "center",
    gap: 2,
    fontSize: S.fontMicro,
    fontWeight: 500,
    padding: theme.spacing(0.125, 0.625),
    borderRadius: S.kbdRadius,
    background: S.triggerKbdBg,
    border: S.triggerKbdBorder,
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
}));
